<template>
  <div class="overview-content">
    <div class="view-tip">点击相应区域，选择供奉区域!</div>
    <div class="view-box">
      <div class="full-content" v-if="loading">
        <a-spin />
      </div>
      <a-row :gutter="24" class="region-list" v-else-if="regionList.length">
        <a-col
          :span="4"
          v-for="item in regionList"
          :key="item.id"
          @click="selectRegion(item)"
        >
          <div class="region-item" :class="{ active: item.id == regionId }">
            <div class="region-name">{{ item.name }}</div>
            <div class="region-count">{{ item.count }}</div>
          </div>
        </a-col>
      </a-row>
      <div class="full-content" v-else>
        <a-empty description="暂无区块" :image="emptyImage"></a-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from "ant-design-vue";

export default {
  name: "OverviewContent",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    // 区域id
    value: {
      type: Number,
    },
    regionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      emptyImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
  computed: {
    regionId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    selectRegion(item) {
      this.regionId = item.id;
      this.$emit("select", item);
    },
    refresh() {},
  },
};
</script>

<style lang="less" scoped>
.overview-content {
  padding: 12px;
  overflow: auto;
}
.view-tip {
  font-size: 20px;
}
.refresh-icon {
  cursor: pointer;
}
.view-box {
  padding: 32px;
}
.region-list {
  width: 100%;
}
.region-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
  border: 2px solid #ccc;
  cursor: pointer;
  padding: 10px;

  &.active {
    color: #ffce7e;
    border: 2px solid #ffce7e;
  }
}
.region-name {
  font-size: 20px;
}
.region-count {
  font-size: 18px;
  margin-top: 12px;
}
.full-content {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
